<template>
    <a-form-model :label-col="{span: 5}" :wrapper-col="{span: 19}">
        <a-form-model-item label="拍摄人员" required style="margin-bottom: 20px;">
            <AlbumGrapher
                :album-id="albumId" :allowClear="true" :disabled="!isManager"
                placeholder="请选择上传图片所属的拍摄人员" v-model="member_id"/>
        </a-form-model-item>
        <a-form-model-item label="选择图片" required style="margin-bottom: 15px;">
            <a-space :size="8">
                <a-button @click="dirUpload" icon="folder">选择文件夹</a-button>
                <a-button @click="batchFile" icon="file">批量选择文件</a-button>
                <span>可选择多次后上传</span>
            </a-space>
            <div style="display: none;">
                <input @change="fileSelect" multiple ref="dirUploadInput" type="file" webkitdirectory/>
                <input @change="fileSelect" multiple ref="batchFileInput" type="file"/>
            </div>
        </a-form-model-item>
        <a-form-model-item label="上传原图" style="margin-bottom: 5px;">
            <a-checkbox :disabled="lockOrigin" v-model="origin">选择图片是原图，直接上传不进行任何处理</a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="修图标记" style="margin-bottom: 5px;">
            <a-checkbox v-model="retouch">选择图片已修图，上传后自动标记为已修图</a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="强制覆盖">
            <a-checkbox v-model="override">忽略系统跳过规则，重新上传所有选择文件</a-checkbox>
        </a-form-model-item>
        <div style="width: 240px; margin: 0 auto; text-align: center;">
            <a-button block disabled icon="sync" shape="round" type="primary" v-if="files.length===0">确认上传</a-button>
            <a-button block disabled icon="sync" shape="round" type="primary" v-else-if="!member_id">确认上传 {{files.length}} 个</a-button>
            <a-button :loading="preparing" @click="start" block icon="sync" shape="round" type="primary" v-else>确认上传 {{files.length}} 个</a-button>
            <div style="margin-top: 20px;">
                <StateCheckbox v-model="agree" state-key="upload.agreement">我已阅读并同意
                    <a href="https://gm.efoto.me/term/grapher-contract" target="_blank">EFOTO摄影合同</a></StateCheckbox>
            </div>
        </div>
        <UploadAlert :album-id="albumId"/>
    </a-form-model>
</template>

<script>
    import api from "../../../../../utils/api";
    import func from "../../../../../utils/func";
    import enums from "../../../../../utils/enums";
    import AlbumGrapher from "../../comps/AlbumGrapher";
    import UploadAlert from "./UploadAlert";
    import cache from "../../../../../utils/cache";
    import StateCheckbox from "../../../../../comps/StateCheckbox";

    export default {
        name: "UploadForm",
        components: {StateCheckbox, UploadAlert, AlbumGrapher},
        props: {
            albumId: String,
            resizeLong: Number
        },
        data() {
            return {
                files: [],
                member_id: "",
                agree: false,
                origin: this.resizeLong === 0,
                retouch: false,
                override: false,
                preparing: false,
                isManager: false,
                uniqueKeys: {},
            }
        },
        computed: {
            lockOrigin() {
                return this.resizeLong === 0
            }
        },
        mounted() {
            cache.v1.album.member.unique(this.albumId)
                .then(res => {
                    this.isManager = enums.Role.isManager(res["roles"]);
                    if (enums.Role.isGrapher(res["roles"])) this.member_id = res.id;
                });
        },
        methods: {
            start() {
                if (!this.agree) {
                  return this.$message.error("请先阅读并同意EFOTO摄影合同");
                }
                this.preparing = true;
                func.setTimeout(100, () => {
                    this.prepareUpload()
                        .then(() => {
                            this.$emit("start", this.files, {
                                member_id: this.member_id,
                                retouch: this.retouch ? 1 : 2,
                            });
                        })
                        .catch(console.log) // debug
                        .finally(() => this.preparing = false);
                });
            },
            dirUpload() {
                this.$refs.dirUploadInput.click();
            },
            batchFile() {
                this.$refs.batchFileInput.click();
            },
            fileSelect(evt) {
                evt.target.files.forEach(handle => {
                    let file = {
                        name: handle.name,
                        size: handle.size,
                        time: (handle.lastModified / 1000).toFixed(0),
                        skip: false,
                        return: false,
                        handle: handle,
                    };
                    let parts = handle.name.split("#");
                    if (parts.length === 3) { // 回传
                        file.return = true;
                        file.type = parts[0];
                        file.time = parts[1];
                        file.name = parts[2];
                    }
                    let key = `${file.time}#${file.name}`;
                    let skip = func.isDefined(this.uniqueKeys[key])
                        && this.uniqueKeys[key] === file.size;
                    if (skip) return; // skip the same one
                    this.uniqueKeys[key] = file.size;
                    let suffix = file.name.split(".").pop();
                    if (enums.Suffix.isImg(suffix)) {
                        this.files.push(file);
                    } else if (enums.Suffix.isRaw(suffix)) {
                        file.type = enums.Upload.TypeRaw;
                        this.files.push(file);
                    }
                });
            },
            async prepareUpload() {
                this.files.sort((a, b) => {
                    return a.time - b.time;
                });
                let start = this.files[0].time - 1;
                let finish = this.files[this.files.length - 1].time + 1;
                let photos = await api.v1.album.photo.ready(this.albumId, start, finish);
                this.files.forEach((file, index) => {
                    file.index = index;
                    file.relate_id = "";
                    if (!func.isDefined(file.type)) {
                        file.type = this.origin ? enums.Upload.TypeOrigin : enums.Upload.TypeHD;
                    }
                    let name = func.trimSuffix(file.name);
                    let key = `${file.time}#${name}`;
                    if (func.isDefined(photos[key])) {
                        file.relate_id = photos[key].id;
                        file.skip = this.compareSize(file.type, photos[key], file.size, file.return);
                    }
                });
            },
            compareSize(type, photo, size, returnUpload) {
                const {raw_size, foto_size, origin} = photo;
                if (this.override) return false; // 强制覆盖
                if (returnUpload) return foto_size === size; // 回传判断大小变化
                if (enums.Upload.isRaw(type)) return raw_size === size; // raw无压缩
                if (enums.Upload.isOrigin(type)) return origin; // 如果已是原图的跳过
                return true // 高清图直接全部跳过，只能开启强制覆盖
            }
        }
    }
</script>
